<script>
    import Modal from "sv-bootstrap-modal";
    export let isOpen = false, title;
</script>

<Modal bind:open={isOpen} dialogClasses="modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{title}</h5>
            <button type="button" class="btn-close" on:click={() => isOpen = false} aria-label="Close" />
        </div>
        <div class="modal-body">
            <slot name="body" />
        </div>
        <div class="modal-footer">
            <slot name="footer">
              <button type="button" on:click={() => isOpen = false} class="btn btn-outline-primary mr-3 btn-sm">Close</button>
            </slot>
        </div>
    </div>
</Modal>

<style>
</style>
